import(/* webpackMode: "eager" */ "/vercel/path0/app/analytics/page.tsx");
